import Vue from "vue"
import {APIHOST} from "@/settings/server";
import $store from "@/store"
import _ from 'underscore'

class DistributionService {
    sendToPostOffice({region, area, client, mails}) {
        let mailsWithPostIndex = _.filter(mails, function (x) {
           return x?.postIndex != null
        }).map(function (x) {
            return {
                Id: x.uid,
                PostCode: x?.postIndex?.postCode
            }
        });
        return Vue.axios.put(`${APIHOST}/api/MailDistribution`, {
            MailPostIndexes: mailsWithPostIndex ? mailsWithPostIndex : null,
            Client: client ? client.id : null,
            Region: region ? region.id : null,
            Area: area ? area.id : null
        },{
              headers: {
                  'Authorization': `Bearer ${$store.getters.accessToken}`
              }
            }
        )
    }
}

export default new DistributionService()
